'use strict';


/**
 * Usages:
 *        1. ({'data-x':1, 'data-y':2, 'otherdata':3}).filterKeys('data-*') => {data-x:1, data-y:2}
 *        2. ({'data-x':1, 'data-y':2, 'otherdata':3}).filterKeys(['data-x', 'otherdata']) => {data-x:1, otherdata:3}
 *        3. ({'data-x':1, 'data-y':2, 'otherdata':3}).filterKeys(['data-*', 'otherdata']) => {data-x:1, data-y:2, otherdata:3}
 */

Object.defineProperty(Object.prototype, 'filterKeys', {
    value: function (filter) {
        let returnObj = {};
        if (typeof filter === 'undefined') {
            returnObj = this;
        } else if (Array.isArray(filter)) {
            filter.map(f => {
                returnObj = {...returnObj, ...this.filterKeys(f)};
            });
        } else if (filter.indexOf('*') === -1 && filter.indexOf('+') === -1) {
            if (Object.hasOwnProperty.call(this, filter)) {
                returnObj[filter] = this[filter];
            }
        } else {
            var filterRegex = '^' + filter.replaceAll('*', '.*').replaceAll('+', '.+') + '$';

            for (var key in this) {
                if (Object.hasOwnProperty.call(this, key) && key.match(filterRegex)) {
                    returnObj[key] = this[key];
                }
            }
        }

        return returnObj;

    },
    enumerable: false,
    writable: true
});